import classNamesOriginal, { ArgumentArray } from "classnames";
import { overrideTailwindClasses } from "tailwind-override";

const overrideClasses = (...args: ArgumentArray): string => {
  return overrideTailwindClasses(classNamesOriginal(...args));
};

export default overrideClasses;
